import {
  BreakConfigurationFragment,
  GetBreakConfigurationsDocument,
  GetBreakConfigurationsQueryVariables,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

interface Result {
  loading: boolean
  breakConfigurations: BreakConfigurationFragment[]
  archivedBreakConfigurations: BreakConfigurationFragment[]
}

export const useGetBreakConfigurations = (
  variables: GetBreakConfigurationsQueryVariables
): Result => {
  const { loading, data } = useQuery(GetBreakConfigurationsDocument, { variables })
  const breakConfigurations = data ? data.timeSettings.breakConfigurationsConnection.nodes : []
  const archivedBreakConfigurations = breakConfigurations
    ? breakConfigurations.filter((bc) => bc.archived)
    : []

  return {
    loading,
    breakConfigurations,
    archivedBreakConfigurations,
  }
}
